import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OperatorState } from 'config/types/configurator'

const initialState: OperatorState = {
  statusCode: 0,
  message: '',
  data: {},
  success: false,
}

const operatorSlice = createSlice({
  name: 'operators',
  initialState,
  reducers: {
    setOperators: (state, action: PayloadAction<any>) => {
      return { ...state, ...action.payload }
    },
  },
})

export const { setOperators } = operatorSlice.actions
export default operatorSlice.reducer
